export default __webpack_public_path__ + "static/media/chicken-cone.456cf7de.jpg";